export default __webpack_public_path__ + "0b1ac12d1b968418525f08f2efa2d6ca.jpg";